exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-snack--active[data-v-55ce69a1] {\n  cursor: pointer;\n}\n.unread[data-v-55ce69a1] {\n  height: 8px;\n  width: 8px;\n  background-color: blue;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 5px;\n}\n.v-list__tile__action[data-v-55ce69a1] {\n  min-width: 40px;\n}\n", ""]);

// exports
